import type { Dispatch, SetStateAction } from 'react';

export type IWebhookType = 'invoice' | 'abandonment';

export type IWebHookFilter = {
  name: string;
  url: string;
  type: IWebhookType;
};

export const WebhookTypes = [
  { label: 'Fatura', value: 'invoice' },
  { label: 'Abandono de carrinho', value: 'abandonment' },
];

export interface IWebHookContext {
  list: IWebHookList[];
  setList: Dispatch<SetStateAction<IWebHookList[]>>;
  updateList: () => void;

  filtersWebhook: IWebHookFilter;
  setFiltersWebhook: Dispatch<SetStateAction<IWebHookFilter>>;
}

export interface IWebHookList {
  created_at: string;
  customer_id: number;
  deleted: boolean;
  description: string;
  internal: boolean;
  product_id: number;
  product_name: string;
  status: boolean;
  updated_at: string;
  url: string;
  __v: number;
  _id: string;
  type: IWebhookType;
}

export interface IFieldsTestWebHook {
  type: string;
  status: number;
}

export interface IFieldsWebHook {
  name: string;
  product: number;
  url: string;
  type: IWebhookType;
}

export interface IProductWebhook {
  productId: number;
  title: string;
}
